export default {
  '报表类型': 'Report Type',
  '方案配置': 'Scheme Configuration',
  '添加方案': 'Add Scheme',
  '将报表方案配置至相应设备类型': 'Configure the Report Scheme to the Corresponding Device Type',
  '手机/平板': 'Mobile/PAD',
  '电脑': 'PC',
  '剩余可用字段': 'Remaining Available Fields',
  '当前使用字段': 'Currently Used Field',
  '可长按拖动排序': '',
  '基础': 'Basic',
  '提示': 'Hint',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '重命名': 'Rename',
  '请输入方案名': 'Enter Scheme Name',
  '当前方案正在使用中，无法删除！': 'The current scheme is in use and cannot be deleted!',
  '确认删除该方案吗？': 'Sure to cancle the scheme?',
  '确认将该方案应用于手机/平板端吗？': 'Are you sure you want to switch the device type to mobile / PAD?',
  '确认将该方案应用于电脑端吗？': 'Are you sure you want to switch the device type to PC?',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗?': 'Quit lost record has operated without saving program. Confirm exit?',
  '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存': 'Do this will refresh the page, make sure that the right side of the field sheme configuration has been saved',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗？': 'Quit lost record has operated without saving program. Confirm exit?',
  '确定命名后会刷新页面，请确认右侧字段已保存': 'After determining the name will refresh the page, make sure the right side of the field has been saved',
  '确定应用后会刷新页面，请确认右侧字段已保存': 'After determining the application  will refresh the page, make sure the right side of the field has been saved',
  '报表方案配置': 'Report Scheme Configuration',
  '方案保存成功': 'Scheme Save Successed',
  '方案重命名成功': 'Scheme Re-name Successed',
  '设备类型激活成功': 'Device Type Active Successed',
  '删除方案成功': 'Delete Successed',
  '添加成功': 'Added',
  '保存': 'Sava',
  '确定删除后会刷新页面，请确认右侧字段已保存': 'After deleting  will refresh the page, make sure the right side of the field has been saved'
}


// WEBPACK FOOTER //
// ./src/i18n/en/report.js